import pluralize from '@sravni/utils/lib/pluralize';

import { Currency } from '../../constants/currency';
import type { Condition } from '../../hooks/useProductData';
import { getAmountString } from '../humanization';

export const getCreditCardConditions = (item): Condition[] => {
  const conditions = [];

  const { maintenancePrice, interestFreePeriodPurchase } = item;

  const cost = maintenancePrice ? `${getAmountString(maintenancePrice, Currency.RUB)} в год` : 'бесплатно';

  conditions.push({ value: cost, description: 'Обслуживание' });

  if (interestFreePeriodPurchase) {
    conditions.push({
      value: `до ${interestFreePeriodPurchase} ${pluralize(interestFreePeriodPurchase, 'дня', 'дней', 'дней')}`,
      description: 'Льготный период',
    });
  }

  return conditions;
};
